const basePink = "#eb5e70";

export function IconVK() {
  return (
    <a
      href="https://vk.com/club178616907"
      target="_blank"
      style={{ paddingTop: "4px" }}
    >
      <svg
        viewBox="0 0 448 512"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={basePink}
          d="M31.5 63.5C0 95 0 145.7 0 247v18c0 101.3 0 152 31.5 183.5S113.7 480 215 480h18c101.3 0 152 0 183.5-31.5S448 366.3 448 265v-18c0-101.3 0-152-31.5-183.5S334.3 32 233 32h-18C113.7 32 63 32 31.5 63.5zm44.1 104.8h51.1c1.7 85.5 39.4 121.7 69.3 129.1V168.3h48.2V242c29.5-3.2 60.4-36.8 70.9-73.7h48.2c-4 19.1-11.8 37.3-23.1 53.3s-25.7 29.5-42.5 39.6c18.7 9.3 35.2 22.4 48.4 38.6 13.3 16.1 22.9 34.8 28.4 54.9h-53.1c-4.8-17.4-14.8-33.1-28.5-44.9a92.392 92.392 0 00-48.7-21.7v66.6h-5.8c-102.1 0-160.4-70-162.8-186.4z"
        />
      </svg>
    </a>
  );
}

// export function IconYT() {
//   return (
//     <a
//       href="https://www.youtube.com/channel/UCvdTyDDtO3lIdul0QYltepw"
//       target="_blank"
//       style={{ paddingTop: "4px" }}
//     >
//       <svg
//         viewBox="0 0 576 512"
//         width="20px"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           fill={basePink}
//           d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C14.9 167 14.9 256.4 14.9 256.4s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6V175.2l142.7 81.2-142.7 81.2z"
//         />
//       </svg>
//     </a>
//   );
// }

// export function IconInsta() {
//   return (
//     <a
//       href="https://www.instagram.com/minimath239/"
//       target="_blank"
//       style={{ paddingTop: "4px" }}
//     >
//       <svg
//         viewBox="0 0 448 512"
//         width="16px"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           fill={basePink}
//           d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
//         />
//       </svg>
//     </a>
//   );
// }

export function IconEnvelope(props: { bw: boolean }) {
  return (
    <svg
      viewBox="0 -52 512 512"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.bw ? "black" : basePink}
        d="M64 112c-8.8 0-16 7.2-16 16v22.1l172.5 141.6c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
      />
    </svg>
  );
}

export function IconTG(props: { bw: boolean }) {
  return (
    <a href="https://t.me/Fefelova_OM" target="_blank">
      <svg
        viewBox="0 0 496 512"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "relative", top: "2px" }}
      >
        <path
          fill={props.bw ? "black" : basePink}
          d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm115 168.7c-3.7 39.2-19.9 134.4-28.1 178.3-3.5 18.6-10.3 24.8-16.9 25.4-14.4 1.3-25.3-9.5-39.3-18.7-21.8-14.3-34.2-23.2-55.3-37.2-24.5-16.1-8.6-25 5.3-39.5 3.7-3.8 67.1-61.5 68.3-66.7.2-.7.3-3.1-1.2-4.4s-3.6-.8-5.1-.5q-3.3.7-104.6 69.1-14.8 10.2-26.9 9.9c-8.9-.2-25.9-5-38.6-9.1-15.5-5-27.9-7.7-26.8-16.3q.8-6.7 18.5-13.7 108.4-47.2 144.6-62.3c68.9-28.6 83.2-33.6 92.5-33.8 2.1 0 6.6.5 9.6 2.9a10.5 10.5 0 013.5 6.7 43.8 43.8 0 01.5 9.9z"
        />
      </svg>
    </a>
  );
}

export function IconCalendar() {
  return (
    <svg
      viewBox="0 0 448 512"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: "relative", top: "2px" }}
    >
      <path
        fill="#a09ea1"
        d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152V24zM48 192h80v56H48v-56zm0 104h80v64H48v-64zm128 0h96v64h-96v-64zm144 0h80v64h-80v-64zm80-48h-80v-56h80v56zm0 160v40c0 8.8-7.2 16-16 16h-64v-56h80zm-128 0v56h-96v-56h96zm-144 0v56H64c-8.8 0-16-7.2-16-16v-40h80zm144-160h-96v-56h96v56z"
      />
    </svg>
  );
}
